import ValuerAmendFilePreview from "../ValuerAmendFilePreview";
import {useEffect, useState} from "react";
import MimeTypes from "../../../models/MimeTypes";
import valuer_api from "../../../api/valuer";


const ValuerAmendTableScreenshotPreview = (props) => {
    // For Saving
    const summaryId = props.summaryId
    const section = props.section
    const identifier = props.identifier
    const rowIdentifier = props.rowIdentifier
    const columnIdentifier = props.columnIdentifier

    const [value, setValue] = useState({});
    const [rowValues, setRowValues] = useState({})

    // Saving Tracker
    const UpdateParentValue = props.UpdateParentValue
    const AddToQueue = props.AddToQueue
    const RemoveFromQueue = props.RemoveFromQueue
    const AddToErroredSaves = props.AddToErroredSaves

    // Error Handling
    const setErrorMessage = props.setErrorMessage
    const setErrorTitle = props.setErrorTitle

    useEffect(() => {
        if (props.rowValues !== undefined) {
            setRowValues(props.rowValues);
        }
    }, [props.rowValues, props.fileVersion])


    useEffect(() => {
        if (rowValues && rowValues[columnIdentifier] !== undefined) {
            let _vals = rowValues[columnIdentifier]
            // Check if contains a files info if so get its base64 string and add to dict
            if (_vals && _vals["file_path"] && _vals["file_data"] && _vals["filename"]) {
                let file_type = _vals["filename"].split(".").at(-1)
                let FILE_DATA = _vals["file_data"]
                let MIME_TYPE = MimeTypes[file_type]
                _vals["base64"] = "data:" + MIME_TYPE + ";base64," + FILE_DATA
            }
            setValue(_vals);
        }
    }, [rowValues, columnIdentifier, props.fileVersion])

    const DeleteFunction = (fileIndex) => {
        // FileIndex is redundant for single preview in table but required for component
        if (!identifier || !columnIdentifier || !rowIdentifier) return
        let updateTime = Date.now()
        AddToQueue(section, identifier, updateTime)
        let body = {
            "value": {"file_path": ""},
            "row": rowIdentifier
        }
        let rv_copy = Object.assign({}, rowValues)
        rv_copy[columnIdentifier] = {}
        UpdateParentValue(identifier, rv_copy, rowIdentifier)
        let response = valuer_api.ValuerAmendPut(summaryId, section, columnIdentifier, body);
        response.then(
            response => {
                RemoveFromQueue(section, identifier, updateTime)
            }
        ).catch((err) => {
            AddToErroredSaves(section, identifier, updateTime)
            setErrorTitle("Failed to Save Files")
            setErrorMessage("The request to save the files has failed")
        })

    }

    return (
        <div className="valuer-amend-table-image-upload-preview">
            <ValuerAmendFilePreview filename={value?.filename}
                                    file_base64={value?.base64}
                                    fileIndex={1}
                                    fileWidth={'120px'}
                                    fileHeight={'70px'}
                                    setErrorMessage={setErrorMessage}
                                    setErrorTitle={setErrorTitle}
                                    deleteActive={true}
                                    deleteFunction={DeleteFunction}
            />
        </div>
    )
}

export default ValuerAmendTableScreenshotPreview